import Axios from "axios";

export default {
    ensureLoadTypesForSelect: (context) => {
        if (context.state.isLoadingTypesForSelect || context.state.isLoadedTypesForSelect) {
            return;
        }

        context.dispatch('loadTypesForSelect');
    },
    ensureLoadLimitsTemplates: (context) => {
        if (context.state.limitsTemplatesIsLoading || context.state.limitsTemplatesIsLoaded) {
            return;
        }

        context.dispatch('loadLimitsTemplates');
    },
    loadLimitsTemplates: (context) => {
        if (context.state.limitsTemplatesIsLoading) {
            return
        }

        context.state.limitsTemplatesIsLoading = true;

        Axios({
            url: '/api/v1/limits-templates/all',
            method: 'GET',
        }).then(resp => {
            context.commit('limitsTemplatesLoaded', resp.data);
        }).catch(() => {
            context.commit('limitsTemplatesLoaded', null);
        }).finally(() => {
            context.state.limitsTemplatesIsLoading = false;
        });
    },
    ensureLoadSidebetNames: (context) => {
        if (context.state.sidebetNamesIsLoading || context.state.sidebetNamesIsLoaded) {
            return;
        }

        context.dispatch('loadSidebetNames');
    },
    reloadSidebetNames: (context) => {
        context.state.sidebetNamesIsLoaded = false;

        return context.dispatch('loadSidebetNames');
    },
    loadSidebetNames: (context) => {
        if (context.state.sidebetNamesIsLoading) {
            return;
        }

        context.state.sidebetNamesIsLoading = true;

        return Axios({
            url: '/api/v1/sidebet-names/all',
            method: 'GET',
        }).then(resp => {
            context.commit('sidebetNamesLoaded', resp.data);
        }).catch(() => {
            context.commit('sidebetNamesLoaded', null);
        }).finally(() => {
            context.state.sidebetNamesIsLoading = false;
        });
    },
    loadTypesForSelect: (context) => {
        if (context.state.isLoadingTypesForSelect) {
            return;
        }

        context.state.isLoadingTypesForSelect = true;

        Axios({
            url: '/api/v1/limits/types-for-select',
            method: 'GET',
        }).then(resp => {
            context.commit('typesForSelectLoadSuccess', resp.data);
        }).catch((err) => {
            context.commit('typesForSelectLoadFailure', err);
        }).finally(() => {
            context.state.isLoadingTypesForSelect = false;
        });
    },
    ensureLoadOperatorsForSelect: (context) => {
        if (context.state.isLoadedOperatorsForSelect || context.state.isLoadingOperatorsForSelect) {
            return;
        }

        context.dispatch('loadOperatorsForSelect');
    },
    reloadOperatorsForSelect: (context) => {
        context.state.isLoadedOperatorsForSelect = false;

        return context.dispatch('loadOperatorsForSelect');
    },
    loadOperatorsForSelect: (context) => {
        if (context.state.isLoadingOperatorsForSelect) {
            return;
        }

        context.state.isLoadingOperatorsForSelect = true;

        Axios({
            url: '/api/v1/limits/operators-for-select',
            method: 'GET',
        }).then(resp => {
            context.commit('operatorsForSelectLoadSuccess', resp.data);
        }).catch((err) => {
            context.commit('operatorsForSelectLoadFailure', err);
        }).finally(() => {
            context.state.isLoadingOperatorsForSelect = false;
        });
    },
    ensureLoadCurrenciesForSelect: (context) => {
        if (context.state.isLoadingCurrenciesForSelect || context.state.isLoadedCurrenciesForSelect) {
            return;
        }

        context.dispatch('loadCurrenciesForSelect');
    },
    loadCurrenciesForSelect: (context) => {
        if (context.state.isLoadingCurrenciesForSelect) {
            return;
        }

        context.state.isLoadingCurrenciesForSelect = true;

        Axios({
            url: 'api/v1/limits/currencies-for-select',
            method: 'GET',
        }).then(resp => {
            context.commit('currenciesForSelectLoadSuccess', resp.data);
        }).catch((err) => {
            context.commit('currenciesForSelectLoadFailure', err);
        }).finally(() => {
            context.state.isLoadingCurrenciesForSelect = false;
        });
    },
    loadDefaultSettings: (context, gameType) => {
        if (context.state.isLoadingDefaultSettings[gameType]) {
            return;
        }

        context.state.isLoadingDefaultSettings[gameType] = true;

        return Axios({
            url: 'api/v1/limits/type/' + gameType,
            method: 'GET',
        }).then(resp => {
            context.commit('defaultSettingsLoadSuccess', {gameType, settings: resp.data});
        }).catch((err) => {
            context.commit('defaultSettingsLoadFailure', {gameType, error: err});

            throw err;
        }).finally(() => {
            context.state.isLoadingDefaultSettings[gameType] = false;
        });
    },
    loadCopyFilter: (context, params) => {
        return Axios({
            url: 'api/v1/limits/filter',
            params: params,
            method: 'GET',
        }).then(resp => {
            context.commit('loadCopyFilter', resp.data);
        }).catch((err) => {
            context.commit('loadCopyFilterFailure', err);

            throw err;
        }).finally(() => {
        });
    },
};
